import { Link } from "react-router-dom";
import { Instagram, Twitter } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-border/50 bg-background">
    <div className="container mx-auto px-4 py-16">
      <div className="grid gap-12 md:grid-cols-4">
        <div>
          <Link to="/" className="font-display text-2xl font-bold">
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">GONVEX</span>
          </Link>
          <p className="mt-4 text-sm text-muted-foreground">Your World, Under Absolute Command.</p>
          <div className="mt-4 flex gap-3">
            <a href="https://www.instagram.com/gonvex.gears" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-full border border-border p-2 transition-colors hover:border-primary hover:text-primary">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="https://x.com/gonvex" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="rounded-full border border-border p-2 transition-colors hover:border-primary hover:text-primary">
              <Twitter className="h-4 w-4" />
            </a>
          </div>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-wider">Gears</h3>
          <div className="mt-4 flex flex-col gap-2">
            <Link to="/shop" className="text-sm text-muted-foreground hover:text-foreground">All Products</Link>
            <Link to="/shop" className="text-sm text-muted-foreground hover:text-foreground">New Arrivals</Link>
            <Link to="/shop" className="text-sm text-muted-foreground hover:text-foreground">Best Sellers</Link>
          </div>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-wider">Company</h3>
          <div className="mt-4 flex flex-col gap-2">
            <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground">Contact</Link>
          </div>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-wider">Support</h3>
          <div className="mt-4 flex flex-col gap-2">
            <Link to="/shipping-returns" className="text-sm text-muted-foreground hover:text-foreground">Shipping & Returns</Link>
            <Link to="/faq" className="text-sm text-muted-foreground hover:text-foreground">FAQ</Link>
            <Link to="/size-guide" className="text-sm text-muted-foreground hover:text-foreground">Size Guide</Link>
            <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground">Privacy Policy</Link>
            <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground">Terms of Service</Link>
          </div>
        </div>
      </div>
      <div className="mt-12 border-t border-border/50 pt-8 text-center text-xs text-muted-foreground">
        © 2026 Gonvex. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;